import { useEffect, useState } from 'react';
import { computeLotCountdown, type LotCountdownParts } from './lotDisplayUtils';

export function useLotCountdown(endDate?: string | null): LotCountdownParts | null {
  const [parts, setParts] = useState<LotCountdownParts | null>(() =>
    endDate ? computeLotCountdown(endDate) : null
  );

  useEffect(() => {
    if (!endDate) {
      setParts(null);
      return;
    }

    const tick = () => setParts(computeLotCountdown(endDate));
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [endDate]);

  return parts;
}
